export default __webpack_public_path__ + "static/media/iconGear.fde323d1.svg";